<div class="ag-theme-material grid-wrapper">
  <ag-grid-angular [columnDefs]="columnDefs" [components]="components" [gridOptions]="gridOptions" [rowData]="data" style="width: 100%; height: 100%">
  </ag-grid-angular>
</div>
